import { actions } from '../../utils/constants';

export const fetchQuestions = ({
    orderBy,
    orderMode,
    status,
    enabled,
    searchTitle,
    limit,
    page,
}) => ({
    type: actions.ASYNC_FETCH_QUESTIONS,
    payload: {
        orderBy,
        orderMode,
        status,
        enabled,
        searchTitle,
        limit,
        page,
    },
});

export const changeShowModalConfirmDisable = showModal => ({
    type: actions.CHANGE_SHOW_MODAL_DISABLE_QUESTION,
    payload: showModal,
});

export const changeShowModalConfirmRemove = showModal => ({
    type: actions.CHANGE_SHOW_MODAL_REMOVE_QUESTION,
    payload: showModal,
});

export const asyncEnableQuestion = ({
    questionId,
    title,
    enabled,
    options,
}) => ({
    type: actions.ASYNC_HANDLE_ENABLE_QUESTION,
    payload: { questionId, title, enabled, options },
});

export const asyncRemoveQuestion = ({ questionId }) => ({
    type: actions.ASYNC_REMOVE_QUESTION,
    payload: { questionId },
});

export const changeShouldBeRefreshQuestionsDatabase = shouldBeRefresh => ({
    type: actions.CHANGE_SHOULD_BE_REFRESH_QUESTIONS_DATABASE,
    payload: shouldBeRefresh,
});



// WEBPACK FOOTER //
// ./src/components/questions-database/questions-database.actions.js